import { render, staticRenderFns } from "./gallery-item.vue?vue&type=template&id=4c4dfe7e&scoped=true&"
import script from "./gallery-item.ts?vue&type=script&lang=ts&"
export * from "./gallery-item.ts?vue&type=script&lang=ts&"
import style0 from "./gallery-item.scss?vue&type=style&index=0&id=4c4dfe7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4dfe7e",
  null
  
)

export default component.exports